import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {StatusConfirmDialogComponent} from "./status-confirm-dialog.component";
import {IExpertiseDoc} from "../../../../shared/services/expertise.service";

@Component({
  selector: 'app-status-check',
  template: `
    <div class="status-check" (click)="changeStatus()" [class.active]="isActive">
      <ng-container *ngIf="isActive; else notActive">
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 16.5H16V8.5H18V16.5C18 17.6 17.1 18.5 16 18.5H2C0.9 18.5 0 17.6 0 16.5V2.5C0 1.4 0.9 0.5 2 0.5H12V2.5H2V16.5Z" fill="#07A403"/>
          <path d="M3.5 8.99961L4.9 7.59961L8 10.6996L16.6 2.09961L18 3.49961L8 13.4996L3.5 8.99961Z" fill="#07A403"/>
        </svg>
        <span>Действующая</span>
      </ng-container>
      <ng-template #notActive>
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 1.5H16C16.5477 1.5 17 1.95228 17 2.5V16.5C17 17.0477 16.5477 17.5 16 17.5H2C1.45228 17.5 1 17.0477 1 16.5V2.5C1 1.95228 1.45228 1.5 2 1.5Z" stroke="#8E9BAF" stroke-width="2"/>
        </svg>
        <span>Недействующая</span>
      </ng-template>
    </div>
  `,
  styles: [`
    .status-check {
      display: flex;
      gap: 10px;
      align-items: center;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;

      &.active {
        color: rgba(7, 164, 3, 1);
      }
    }
  `]
})
export class StatusCheckComponent {
  @Input() expertise: IExpertiseDoc;
  @Input() isActive: boolean;
  @Input() livingComplexID: number;
  @Input() regionID: number;
  @Output() onChangeActive = new EventEmitter<boolean>();

  constructor(private dialog: MatDialog,) {
  }


  changeStatus() {
    this.dialog.open(StatusConfirmDialogComponent, {
      width: '500px',
      data: {
        isActive: this.isActive,
        expertise: this.expertise,
        livingComplexID: this.livingComplexID,
        regionID: this.regionID
      },
      autoFocus: false
    }).afterClosed().subscribe(res => {
      if (typeof res === 'boolean') {
        this.isActive = res;
        this.onChangeActive.emit(this.isActive);
      }
    })
  }
}
